//@author: devin
import { Component, ElementRef, Input, NgZone, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { SearchCriteriaService } from "../../../services/search/search-criteria/search.criteria.service";
import type {
    ExpressSchedulingLocationFilter,
    ExpressSchedulingLocationItem,
} from "../../../standalone/express-scheduling/s25.express.scheduling.types";
import { TypeManagerDecorator } from "../../../main/type.map.service";
import { S25Util } from "../../../util/s25-util";
import { DropdownDataUtil } from "../dropdown.data.util";
import { S25DropdownAbstract } from "../s25.dropdown.abstract";

@TypeManagerDecorator("s25-location-dropdown")
@Component({
    selector: "s25-location-dropdown",
    template: `
        @if (items) {
            <s25-generic-dropdown
                [value]="value()"
                [hasFav]="true"
                [onSelect]="onSelect"
                [items]="items"
                [staticItems]="staticItems"
                [autoOpen]="autoOpen"
                [alwaysOpen]="alwaysOpen"
                [hideSearch]="hideSearch"
                [focusFirst]="true"
                [searchEnabled]="true"
                [apiBean]="apiBean"
                [serverSide]="serverSide"
                [placeholder]="'Search spaces'"
                [resetSelectedOnCleanup]="resetSelectedOnCleanup"
                [ariaLabel]="ariaLabel"
                [blockDetailsNav]="blockDetailsNav"
                (valueChange)="onValueChange($event)"
            />
        }
    `,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class S25LocationDropdownComponent extends S25DropdownAbstract implements OnInit {
    @Input() express?: ExpressSchedulingLocationFilter;

    constructor(
        private elementRef: ElementRef,
        private zone: NgZone,
    ) {
        super();
    }

    ngOnInit() {
        const value = this.value();
        if (value) {
            value.itemTypeId = 4;
        }
        const expressFilter = this.express;
        if (expressFilter) {
            const dateParams =
                expressFilter.startDt && expressFilter.endDt
                    ? "&perm_start_dt=" +
                      S25Util.date.toS25ISODateTimeStr(expressFilter.startDt) +
                      "&perm_end_dt=" +
                      S25Util.date.toS25ISODateTimeStr(expressFilter.endDt)
                    : "";
            SearchCriteriaService.getLocations(
                -999,
                0,
                999,
                null,
                null,
                null,
                "&direct=T&min_ols=R&can_assign=T" + dateParams,
            ).then((data: any) => {
                this.zone.run(() => {
                    const items = SearchCriteriaService.extractItems(data) as ExpressSchedulingLocationItem[];
                    if (items?.length && expressFilter.getAvailableItems) {
                        expressFilter.getAvailableItems(items).then((availItems) => {
                            const favs = availItems.filter((item) => item.favorite === "T");
                            this.staticItems = S25Util.deepCopy(favs);
                            this.items = S25Util.deepCopy(availItems);
                            this.onLoad?.();
                        });
                    } else {
                        this.onLoad?.();
                    }
                });
            });
        } else {
            SearchCriteriaService.getLocations(-999, 0, 999, null, true, null, null).then((data: any) => {
                this.zone.run(() => {
                    this.staticItems = SearchCriteriaService.extractItems(data);
                    this.serverSide = DropdownDataUtil.getServerSideModel(
                        "getLocations",
                        this.elementRef.nativeElement,
                        null,
                    );
                    this.items = S25Util.deepCopy(this.staticItems);
                    this.onLoad && this.onLoad();
                });
            });
        }
    }
}
